export const FETCH_SYLLABUS_REQUEST = 'FETCH_SYLLABUS_REQUEST';
export const FETCH_SYLLABUS_SUCCESS = 'FETCH_SYLLABUS_SUCCESS';
export const FETCH_SYLLABUS_FAILED = 'FETCH_SYLLABUS_FAILED';
